import { AxiosError } from 'axios';

export type ApiErrorInfo = {
  code: string;
  message: string;
  status?: number;
};

const statusCodes: Record<number, string> = {
  400: 'VALIDATION_ERROR',
  401: 'UNAUTHENTICATED',
  403: 'PERMISSION_DENIED',
  404: 'NOT_FOUND',
  409: 'CONFLICT',
  429: 'RATE_LIMITED',
  500: 'INTERNAL_ERROR',
  501: 'NOT_IMPLEMENTED',
  502: 'SERVICE_UNAVAILABLE',
  503: 'SERVICE_UNAVAILABLE',
  504: 'UPSTREAM_TIMEOUT',
};

export const normalizeApiError = (error: unknown): ApiErrorInfo => {
  const err = error as AxiosError<{ code?: string; message?: string; detail?: string }>;
  const response = err?.response;
  const data = response?.data;

  if (data?.code) {
    return { code: data.code, message: data.message ?? '', status: response?.status };
  }
  if (response?.status) {
    return {
      code: statusCodes[response.status] ?? 'INTERNAL_ERROR',
      message: data?.detail ?? data?.message ?? '',
      status: response.status,
    };
  }
  if (err?.code === 'ECONNABORTED') {
    return { code: 'TIMEOUT', message: '' };
  }
  return { code: 'NETWORK_ERROR', message: '' };
};
